import axios from "axios";

export const fetchFeatures = (token) => async (dispatch) => {
  dispatch({ type: "FETCH_FEATURES_REQUEST" });

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL_USER}/featured-link`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    dispatch({ type: "FETCH_FEATURES_SUCCESS", payload: response.data });
  } catch (error) {
    dispatch({ type: "FETCH_FEATURES_FAILURE", payload: error.message });
  }
};
